import { BreakpointObserver } from '@angular/cdk/layout';
import { Component } from '@angular/core';
import { ResponsiveBaseComponent } from 'src/app/core/components/responsive-base/responsive-base.component';
import { CustomerStorySummaryModel } from 'src/app/models/viewmodels/customer-story-summary-model';

@Component({
    selector: 'app-customer-story-vega-life',
    templateUrl: './customer-story-vega-life.component.html',
    styleUrl: './customer-story-vega-life.component.scss',
    standalone: false
})
export class CustomerStoryVegaLifeComponent extends ResponsiveBaseComponent {
 public readonly customerStorySummary: CustomerStorySummaryModel =
    {
      routerLink: 'vega-life',
      title: 'Vega Life',
      description: 'Customer loyalty solutions need to be simple to use and appealing to customers.',
      readingTime: '3 min',
      companyType: 'Vegan',
      companyCategory : 'Retail Store',
      companyLogoUrl: '/assets/img/partners/vega-life.jpg',
      storyImageUrl: '/assets/img/partners/stories/vega-life.jpg',
    };

  constructor(responsive: BreakpointObserver) {
    super(responsive);
  }
}
